<template>
    <ui-dropdown placement="bottom-start" menu-class="w-72 max-w-lg">
        <template #default="dropdownScope">
            <slot v-bind="scope(dropdownScope)"></slot>
        </template>

        <template #menu="{ close }">
            <div class="p-3 max-h-64 overflow-y-auto">
                <!-- Empty State. -->
                <div class="space-y-6">
                    <div v-if="filteredComponents.length > 0">
                        <div class="ml-2 text-xs font-medium text-gray-400 mb-1">Existing Components</div>
                        <div class="space-y-1">
                            <button
                                v-for="knownComponent in filteredComponents"
                                class="flex items-center space-x-2 text-left w-full rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                :title="knownComponent"
                                @click="selectContact(knownComponent, close)"
                            >
                                <div class="truncate flex-1 flex flex-col">
                                    <div class="truncate w-full">{{ knownComponent }}</div>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div v-else class="text-gray-500 text-sm">
                        No matching components found.
                    </div>
                </div>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>

import UiDropdown from "../../../ui/UiDropdown.vue";

export default {
    components: {UiDropdown},
    props: {
        top: Boolean,
        costPlan: Object,
        buttonClass: {
            type: String,
            default: 'text-left w-full rounded-md px-2 py-1 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-600',
        },
    },
    data() {
        return {
            query: '',
            components: [],
        }
    },
    computed: {
        filteredComponents() {
            let options = []
            this.components.forEach((component) => {
                if (this.match(component)) {
                    options.push(component)
                }
            })
            return options
        },
    },
    methods: {
        scope(dropdownScope) {
            return {
                query: this.query,
                setQuery: this.setQuery,
                ...dropdownScope
            }
        },
        setQuery(query) {
            this.query = query
        },
        buildKnownComponents() {
            let options = [];
            this.costPlan.sections.forEach(section => {
                section.tasks.forEach(task => {
                    task.items.forEach(item => {
                        if (item.buildup) {
                            item.buildup.components.forEach(component => {
                                if (options.indexOf(component.name) === -1) {
                                    options.push(component.name)
                                }
                            })
                        }
                    })
                })
            })
            this.components = options;
        },
        match(knownComponent) {
            const query = this.query.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            return !query || query.every((token) => {
                return (knownComponent).toLowerCase().includes(token);
            });
        },
        selectContact(knownComponent, close) {
            this.$emit('selected:knownComponent', knownComponent);
            this.query = knownComponent;
            close();
        },
    },
    mounted() {
        this.buildKnownComponents();
    },
}
</script>
